var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"top"},[_c('div',{staticClass:"mb-5"},[_vm._v("\n        Thanks for Your Question! We have received your message and will reply as soon as we have your answer ready.\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }